export default __webpack_public_path__ + "static/media/image-night-arcade.a5acf9d0.jpg";